import React from 'react';
import Stylesheet from './Data.module.css';
import Button from '../../../../../elements/Button/Button';
import File from '../../../../../elements/File/File';
import { AppContext } from '../../../../../contexts/app';
import { ico_file_csv, ico_file_excel, ico_upload } from '../../../../../icon';
import {user} from '@enigma/core/services';
import { TableContext } from '../../../context/table';
import { QueryContext } from '../../../context/query';
import { addNewRecord } from '../../../Table.Engine';

const Data = (props) => {
    let app = null;
    let table = null;
    let query = null;
    const init = (appContext, tableContext, queryContext) => {
        app = appContext;
        table = tableContext;
        query = queryContext;
    }

    const onImport = file => {
        let reader = new FileReader();
        reader.readAsText(file);
        reader.onload = async function() {
            // disable toolbox during import
            query.setConfig({...table.config, lock: true});
            const result = reader.result;
            var lines = result.split(/[\r\n]+/g);
            // list of records that are approved for import
            let finalCollection = [];
            // list of records that will be ignored during import
            let ignoredCollection = [];
            // list of records that have an invalid structure
            let invalidRecords = [];
            // cycle through each record (line)
            for (let lineIndex = 0; lineIndex < lines.length; lineIndex++) {
                // current line in file
                const record = lines[lineIndex].split(',');
                // ignore empty lines
                if (record.length === 1 && record[0] === "") continue;
                // check if column count matches with current table structure
                if (record.length !== table?.schema.length) {
                    const response = await app.toggleMessageBox('Invalid record structure', 
                    `The record at index '${lineIndex+1}' didnt conform to the current table structure, 
                    do you wish to cancle import ?, by continuing this record will be ignored.`, "yes_no");
                    if (response === "yes"){
                        // re-enable toolbox
                        query.setConfig({...table.config, lock: false});
                        app.toggleToast(ico_upload, "Data import was successfully canceled");
                        return;
                    } else {
                        invalidRecords.push(record);
                        // move to next record
                        continue;
                    }
                }
                // record data
                let metadata = {};
                // cycle through each column in table schema
                for (let columnIndex = 0; columnIndex < table?.schema.length; columnIndex++) {
                    // current table column
                    const column = table?.schema[columnIndex];
                    // column value
                    const cell = record[columnIndex];
                    // ignore blank columns
                    if (cell !== "") {
                        // validate record cell
                        let value = null;
                        if (column.type === "number") 
                            value = parseFloat(cell);
                        else if (column.type === "date" )
                            value = new Date(`${cell} 00:00:00`).getTime();
                        else if (column.type === "notify")
                            value = new Date(`${cell} 00:00:00`).getTime();
                        else if (column.type === "string") 
                            metadata[column.name] = cell;
                        else if (column.type === "table refference")
                            metadata[column.name] = cell;
                        else if (column.type === "file")
                            continue;
                        else value = cell;
                        // check if cell was succesfuly converted
                        if (!isNaN(value) 
                        && column.type !== "string"
                        && column.type !== "table refference") 
                            metadata[column.name] = value;
                        if (isNaN(value)
                        && cell !== "NULL"
                        && column.type !== "string"
                        && column.type !== "table refference") {
                            const response = await app.toggleMessageBox('Invalid cell value', 
                            `The value '${cell}' for column '${column.title}' at record '${lineIndex+1}' 
                            appears to be invalid, for date values make sure it conforms to
                            mm/dd/yyyy format, do you wish to cancle import ?, 
                            by continuing this record will be ignored.`, "yes_no"); 
                            if (response === "yes") {
                                // re-enable toolbox
                                query.setConfig({...table.config, lock: false});
                                app.toggleToast(ico_upload, "Data import was successfully canceled");
                                return;
                            } else {
                                metadata = {};
                                // move to next record
                                continue;
                            }
                        }
                    }
                }
                if (JSON.stringify(metadata) === "{}") 
                    ignoredCollection.push(record)
                else finalCollection.push(metadata);
            }
            // confirm operation
            let message = null;
            if (ignoredCollection.length > 0)
                message = `${ignoredCollection.length} records were ignored, do you still wish to import ?`;
            else if (invalidRecords.length > 0)
                message = `${invalidRecords.length} records didnt conform to the current table 
                structure, do you still wish to import ?`;
            else message = `Are you sure you want to add ${finalCollection.length} records ?.`;
            const response = await app.toggleMessageBox('confirm import', message, "yes_no");
            if (response === "yes") {
                for (const record of finalCollection) {
                    await addNewRecord({
                        ...record,
                        isNew: true, // record is incomplete
                        timestamp: Date.now(),
                        author: user.displayName,
                        branch: app.profile.branch
                    }, table?.metadata);
                }
                // re-enable toolbox
                query.setConfig({...table.config, lock: false});
                app.toggleToast(ico_upload, "import complete.")
            } else {
                // re-enable toolbox
                query.setConfig({...table.config, lock: false});
                app.toggleToast(ico_upload, "Data import was successfully canceled");
                return;
            }
        };
        reader.onerror = function() {
            app.toggleToast(ico_upload, 
            "import failed, file could not opend, try again later.", true)
        };
    }
    const getRecordSet = _ => {
        // search records take priority before all records sets
        if (query.search.records.length > 0) return query.search.records;
        // report records take priority before all records
        else if (query.report.records.length > 0) return query.report.records;
        // use all records
        else return table.records;
    }
    const onExport = _ => {
        // identify export scope
        // selected records
        const isRecords = query?.selected.records.length > 0;
        // all records selected for export
        const isAll = (query?.selected.records.length === 0 
            && query?.selected.columns.length === 0) ||
            (query?.selected.records.length === 1 
            && query?.selected.records[0].id === "all");
        // specific columns selected for export
        const isColumns = query?.selected.columns.length > 0;
        // current clipboard text
        let clipboardString = "";
        // table records
        let currentRecords = getRecordSet();
        // table columns
        let currentColumns = table?.schema;
        // custom records selected
        if (isRecords && !isAll) {
            currentRecords = [];
            // export all selected records
            for (const selectedRecord of query?.selected.records)
                for (const record of query.report.report ? query.report.records : table?.records)
                    if (record.id === selectedRecord.id)
                        currentRecords.push(record);
        } 
        // custom columns selected
        if (isColumns) {
            currentColumns = [];
            // export all selected columns
            for (const selectedColumn of query?.selected.columns) {
                if (selectedColumn === "id" 
                    || selectedColumn === "author" 
                    || selectedColumn === "timestamp") {
                        currentColumns.push({
                            name: selectedColumn, 
                            type: selectedColumn === "timestamp" 
                            ? "date" : null
                        })
                    }
                for (const column of table?.schema)
                    if (selectedColumn === column.name)
                        currentColumns.push(column);
            }
        }
        // copy records to clipboard
        for (const record of currentRecords) {
            // prepend current record id
            if (isAll || isRecords)
                clipboardString += `${record.id}\t`;
            // extract all record columns
            for (const column of currentColumns) {
                if (column.type === "file" && record[column.name])
                    clipboardString += `${record[column.name].url}\t`;
                else if (column.type === "date" && record[column.name])
                    clipboardString += `${new Date(record[column.name]).toDateString()}\t`;
                else if (column.type === "notify" && record[column.name])
                    clipboardString += `${new Date(record[column.name]).toDateString()}\t`;
                else if (column.type === "table refference" && record[column.name])
                    clipboardString += `${record[column.name]}\t`;
                else 
                    clipboardString += `${record[column.name] || "NaN"}\t`;
            } 
            // append record author and record timestamp
            if (isAll || isRecords) {
                clipboardString += `${record.author}\t`;
                clipboardString += `${new Date(record.timestamp).toString()}\t`;
            }
            clipboardString += "\n";
        }
        if (!navigator.clipboard) {
            app.toggleToast(ico_file_excel, 
            "records could not be exported on this device.");
            return;
        }
        navigator.clipboard.writeText(clipboardString).then(function() {
            app.toggleToast(ico_file_excel, 
            "records exported to clipboard succesfuly.");
        }, function(err) {
            app.toggleToast(ico_file_excel, 
            "records could not be exported, try again later");
        });
    }

    const content = config => {
        if (config.toolbox) {
            return (
                <div className={Stylesheet.ButtonGroup}>
                    <div className={Stylesheet.Group}>
                        <h5 className={Stylesheet.Title}>data</h5>
                        {table?.config?.disableImport ? null : 
                        <div className={Stylesheet.BtnImport}>
                            <File onChange={files => onImport(files)} 
                            accept={['text/csv']} 
                            disabled={query?.selected.records?.length > 0 
                            || config?.lock
                            || query?.selected.columns?.length > 0
                            || table?.schema === undefined} />
                            <Button secondary
                            disabled={query?.selected.records?.length > 0
                            || config?.lock
                            || query?.selected.columns?.length > 0
                            || table?.schema === undefined}>
                            {ico_file_csv}&emsp;import</Button>
                        </div>}
                        {table?.config?.disableExport ? null : 
                        <Button onClick={_ => onExport()} primary
                        disabled={table?.records?.length === 0
                        || config?.lock}>
                        {ico_file_excel}&emsp;export</Button>}
                    </div>
                </div>
            )
        }
        else if (config.basic === false) 
            return null;
        else {
            return (
                <React.Fragment>
                    {table?.config?.disableImport ? null : 
                    <div className={Stylesheet.BtnImport}>
                        <File onChange={files => onImport(files)} 
                        accept={['text/csv']} 
                        disabled={query?.selected.records?.length > 0 
                        || config?.lock
                        || query?.selected.columns?.length > 0} />
                        <Button secondary
                        disabled={query?.selected.records?.length > 0
                        || config?.lock
                        || query?.selected.columns?.length > 0}>
                        {ico_file_csv}&emsp;import</Button>
                    </div>}
                    {table?.config?.disableExport ? null : 
                    <Button onClick={_ => onExport()} primary
                    disabled={table?.records?.length === 0
                    || config?.lock}>
                    {ico_file_excel}&emsp;export</Button>}
                </React.Fragment>
            )
        }
    }

    return (
        <AppContext.Consumer>
            {app => (
                <TableContext.Consumer>
                    {table => (
                        <QueryContext.Consumer>
                            {query => (
                                <div className={Stylesheet.Container}>
                                    {init(app, table, query)}
                                    {content(table.config)}
                                </div>
                            )}
                        </QueryContext.Consumer>
                    )}
                </TableContext.Consumer>
            )}
        </AppContext.Consumer>
    )
}

export default Data;